<template>
  <v-form class='viewUserForm' v-model='valid' ref='viewUserForm'>
    <v-container class='mb-10'>
      <v-row>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>UserName : </label>
          <p>{{ user.username ? user.username : '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>User Role : </label>
          <p>{{ user.user_role_name ? user.user_role_name : '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Email : </label>
          <p>{{ user.email ? user.email : '-' }}</p>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <label class='view_label'>Status : </label>
          <p>
            <template>
              <v-chip :color="user.status == 0 ? 'success' : 'warning'" small>{{ user.status == 0 ? 'Active' : 'Inactive' }}</v-chip>
            </template>
          </p>
        </v-col>
      </v-row>
      <v-footer fixed v-if="$checkRight(['edit_user'])">
        <v-col class="text-right">
          <v-btn color="primary" class="mr-2" @click="edit" small>Edit</v-btn>
        </v-col>
      </v-footer>
    </v-container>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.$axios.post('getUserById/' + id).then((res) => {
        this.user = res.data.data
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    } else {
      this.edit_id = undefined
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      user: {},
      error: {}
    }
  },
  methods: {
    edit () {
      const editId = this.$route.params.id
      this.$router.push({ path: `/user/edit/${editId}`, })
    }
  }
}
</script>

<style>
.viewUserForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.viewUserForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.viewUserForm .view_label {
  font-size: 15px;
  font-weight: bold;
}
</style>
